import { Component, OnInit, ViewEncapsulation, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {'id': 'appContactsWrapper'}
})
export class AccountContactsComponent implements OnInit {
  @Output() contactSelectedEmit = new EventEmitter();
  @Input() contactsList: any;

  constructor() { }

  ngOnInit() {
  }

  selectContact(contact) {
    this.contactSelectedEmit.emit(contact);
  }

  favoriteContact() {
    console.log('favoriteContact')
  }

}
